// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@ces/App/Store/Reducers";
import { getDataLayer } from "@ces/XDL/Utilities";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

let lastPageSent: string | null = null;

export const XngGaCustomVirtualPageViewEvent: Handler = ({ getState }) => {
    const state = getState() as CustomAppState;
    const includeEvent = state.xGoogleAnalytics.includeCustomVirtualPageViewEvent;

    if (includeEvent) {
        const session = getSession(state);
        const location = getLocation(state);
        const eventName = state.xGoogleAnalytics.customVirtualPageViewEventName;
        const linkTitle = window.document.title;
        const linkUrl = location.pathname + location.search;
        const userId = session.userProfileId || "";
        const isColonialEmployee = session.properties.isColonialEmployee || false;

        const dataLayer = getDataLayer() || [];

        if (!dataLayer || linkUrl === lastPageSent) {
            return;
        }

        lastPageSent = linkUrl;

        const googleAnalyticsData = {
            event: eventName,
            page: {
                title: linkTitle,
                url: linkUrl,
            },
            "Authentication State": userId ? "Logged In" : "Not Logged In",
            "User ID": userId,
            colonial_emp: isColonialEmployee,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

export const chain = [XngGaCustomVirtualPageViewEvent];

const xngGaCustomVirtualPageViewEvent = createHandlerChainRunner(chain, "XngGaCustomVirtualPageViewEvent");
export default xngGaCustomVirtualPageViewEvent;
